// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import SecretController from "./secret_controller"
application.register("secret", SecretController)

import PasswordGeneratorController from "./password_generator_controller"
application.register("password-generator", PasswordGeneratorController)

import FaviconController from "./favicon_controller"
application.register("favicon", FaviconController)

import EntryKindController from "./entry_kind_controller"
application.register("entry-kind", EntryKindController)
